<div class="d-flex flex-column align-items-center">
    <h1 class="mt-3 mb-3">Recherche de références</h1>
    <hr class="bg-primary py-1 px-5 mb-5 rounded-3 opacity-100 border-primary">
 
    <div id="help-search-menu" class="row text-center">
        <div class="col">
            <a [routerLink] = "['/aide-recherche']" fragment="criteres" class="text-decoration-none">
                01. Des critères de recherche pertinents
                <img class="mt-3" src="assets/images/help-search/nav_criteres.png" alt="">
            </a>
        </div>
 
        <div class="col">
            <a [routerLink] = "['/aide-recherche']" fragment="carte" class="text-decoration-none">
                02. Une zone de recherche précise
                <img class="mt-3" src="assets/images/help-search/nav_carte.png" alt="">
            </a>
        </div>
       
 
        <div class="col">
            <a [routerLink] = "['/aide-recherche']" fragment="resultats" class="text-decoration-none">
                03. Un panier de résultats sélectionnés
                <img class="mt-3" src="assets/images/help-search/nav_resultats.png" alt="">
            </a>
        </div>
    </div>
 
    <div id="criteres">
        <h2 class="mt-5 text-center fw-normal">
            01 - Sélectionnez vos critères afin d’obtenir la liste de références la plus pertinente
        </h2>
 
        <div class="card card-body mb-4 bg-light">
            <h3 class="text-secondary mb-3">
                <img alt="" src="assets/images/help-search/icons/map-pin.png" />&nbsp;Critère localisation
            </h3>
            <div class="d-flex">
                <div>
                    <h4 class="card-title text-black-50">Recherche par l’adresse</h4>
                    <p class="card-text">
                        Saisissez l’adresse précise au numéro, à la voie, à la Commune, ou au département selon le type de bien et la précision de recherche souhaités.
                    </p>
                    <p class="card-text">
                        <img alt="" src="assets/images/help-search/localisation_1.png" />
                    </p>
                </div>
 
                <div>
                    <h4 class="card-title text-black-50">Recherche par la référence cadastrale</h4>
                    <p class="card-text">
                        Plusieurs sections ou parcelles peuvent être saisies en utilisant le bouton « + cadastre ». Cette recherche ne remonte que les références qui sont situées sur la ou les sections ou parcelles saisies.
                    </p>
                    <p class="card-text">
                        <img alt="" src="assets/images/help-search/localisation_2.png" />
                    </p>
                </div>
            </div>
        </div>
 
        <div class="card card-body mb-4 bg-light">
            <h3 class="text-secondary mb-3">
                <img alt="" src="assets/images/help-search/icons/calendar.png" />&nbsp;Critère Période
            </h3>
            <div class="">
                <p class="card-text">
                    La période par défaut est 24 mois. Vous pouvez sélectionner une autre période par défaut.Vous pouvez également déterminer vous-même une période différente en utilisant le calendrier mis à votre disposition sur le lien « période sur mesure »
                </p>
                <p class="d-flex justify-content-evenly">
                    <img class="object-fit-contain" alt="" src="assets/images/help-search/periode_1.png" />
                    <img class="object-fit-contain" alt="" src="assets/images/help-search/periode_2.png" />
                </p>
            </div>
        </div>
 
        <div class="card card-body mb-4 bg-light d-flex flex-column">
            <h3 class="text-secondary mb-3">
                <img alt="" src="assets/images/help-search/icons/home.png" />&nbsp;Critères spécifiques (Ex type de bien)
            </h3>
            <p class="">
                Lorsque le panier de références remonté et encore trop important et afin de sélectionner des actes de vente comparables, vous pouvez ajuster votre sélection avec des critères complémentaires :
            </p>
 
            <div class="row">
                <div class="col">
                    <p class="card-text fw-bold text-black-50">
                        Ouvrez le champ de sélection et indiquez votre choix :
                    </p>
                    <p class="card-text">
                        le critère sera appliqué comme filtre pour les références proposées en aperçu
                    </p>
                    <img class="" alt="" src="assets/images/help-search/specifque_1.png" />
                </div>
                <div class="col justify-content-center">
                    <p class="card-text fw-bold text-black-50">Fermez le champ de sélection :</p>
                    <p class="card-text">le filtre ne sera plus appliqué</p>
                    <img class="" alt="" src="assets/images/help-search/specifque_2.png" />
                </div>
            </div>
        </div>
    </div>
 
    <div id="carte">
        <h2 class="mt-5 text-center fw-normal">
            02 - Utilisez le niveau de zoom de la carte et son centrage pour définir la zone de recherche
        </h2>
 
        <p class="text-center">
            De façon générale, c’est toujours la zone affiché sur la carte à l’écran qui définit la zone de recherche
        <p>
 
        <div class="card card-body mb-4">
            <h3 class="text-secondary mb-3">
                <img alt="" src="assets/images/help-search/icons/ico-map.png" />&nbsp;Le niveau de zoom par défaut
            </h3>
            <div class="">
                <p class="">
                    La saisie de l’adresse dans la rubrique ‘Localisation’ détermine le centrage par défaut votre recherche : les références vont s’afficher par défaut
                </p>
                <div class="text-center">
                    <img class="" alt="" src="assets/images/help-search/zoom.png" />
                </div>
            </div>
        </div>
 
        <div class="card card-body mb-4">
            <h3 class="text-secondary mb-3">
                <img alt="" src="assets/images/help-search/icons/maximize.png" />&nbsp;La détermination de la zone de recherche
            </h3>
 
            <div class="">
                <p class="card-text fw-bold text-black-50">Si seule la Commune a été saisie</p>
 
                <p class="card-text">
                    Le niveau de zoom par défaut encadre la commune entière.Mais vous pouvez tout à fait zoomer (+ et -) sur la carte ou la faire glisser à gauche ou à droite pour définir avec plus de précision la zone de recherche.
                </p>
                <div class="text-center">
                    <img class="" alt="" src="assets/images/help-search/zone_1.png" />
                </div>
 
                <p class="card-text mt-3 fw-bold text-black-50">
                    Si vous donnez une adresse avec le numéro dans la rue, le niveau de zoom sera plus précis, mais là encore, vous avez la main pour modifier la zone de recherche
                </p>
                <div class="text-center">
                    <img class="card-text" alt="" src="assets/images/help-search/zone_2.png" />
                </div>
                <p class="card-text mt-3 fw-bold text-black-50">
                    Dans tous les cas, la liste des références de l’aperçu s’ajustera en fonction de la zone de recherche affichée à l’écran
                </p>
            </div>
        </div>
 
        <div class="card card-body mb-4">
            <h3 class="text-secondary mb-3">
                <img alt="" src="assets/images/help-search/icons/refresh.png" />&nbsp;La possibilité d’afficher le cadastre et/ou la photo aérienne
            </h3>
 
            <p class="card-body fw-bold text-black-50">
                Vous avez la possibilité d’obtenir plus d’informations affichées sur la carte grâce à deux outils
            </p>
 
            <div class="d-flex justify-content-between">
                <div class="">
                    <p class="text-center">Affichage des parcelles cadastrales</p>
                    <img class="" alt="" src="assets/images/help-search/option_cadastre.png" />
                </div>
 
                <div class="">
                    <p class="text-center">Affichage de la photo aérienne</p>
                    <img class="" alt="" src="assets/images/help-search/option_satellite.png" />
                </div>
            </div>
        </div>
    </div>
 
    <div id="resultats">
        <h2 class="mt-5 text-center fw-normal">
            03 - Sélectionnez les références dans l’aperçu pour un panier cohérent
        </h2>
 
        <div class="card card-body mb-4">
            <h3 class="text-secondary mb-3">
                <img alt="" src="assets/images/help-search/icons/list.png" />&nbsp;Les références qui figurent dans l’aperçu par défaut
            </h3>
 
            <div class="d-flex">
                <div class="card-text">
                    <p class="card-text">
                        Les références qui figurent dans l’aperçu sont celles qui correspondent aux critères saisis (localisation, type de bien, période, critères spécifiques) et qui entrent dans la zone de recherche affichée à l’écran.
                    </p>
 
                    <p class="card-text">
                        L’aperçu (ainsi que la carte) peut afficher jusqu’à 60 références.
                    </p>
 
                    <p class="card-text">
                        Les références affichées sont par défaut les plus récentes et sont triées par ordre chronologique dans le tableau.
                    </p>
 
                    <p class="card-text fw-bold text-black-50">Vous pouvez également cliquer sur les gouttes localisant la référence sur la carte :</p>
 
                    <p class="card-text">
                        Vous obtiendrez également le détail du descriptif.<br>
                        La goutte ainsi sélectionnée s’affichera en vert dans le tableau de l’aperçu.
                    </p>
                </div>
 
                <div class="card-text  text-center mb-5">
                    <img alt="" src="assets/images/help-search/tableau_1.png" />
                </div>
            </div>
 
           
        </div>
 
        <div class="card card-body mb-4">
            <h3 class="text-secondary mb-3">
                <img alt="" src="assets/images/help-search/icons/check-square.png" />&nbsp;Les sélections possibles dans le cadre de l’aperçu
            </h3>
 
            <div class="">
                <div class="d-flex mb-3">
                    <div>
                        <strong class="card-text">Cocher les références souhaitées :</strong>
 
                        <p class="card-text">
                            Soit en sélectionnant l’ensemble du tableau, grâce à la coche figurant dans l’en-tête de tableau.
                        </p>
 
                        <p class="card-text">
                            Soit en sélectionnant seulement certaines références, grâce à la coche en début de ligne.
                        </p>
 
                        <p class="card-text">
                            <strong class="">Remarque : </strong> une fois les références sélectionnées dans l’aperçu, elles ne seront plus impactées par les modifications de critères que vous pourrez opérer ensuite (niveau de zoom, surface, nombre de pièces, ou autres..). Si vous souhaitez appliquer un nouveau critère à l’ensemble de l’aperçu, vous devrez décocher la sélection.
                        </p>
 
                        <strong class="card-text">Compléter son panier avec un niveau de zoom différent</strong>
 
                        <p class="card-text">
                            Les références cochées ne sortent pas de l’aperçu en cas de changement de zoom. Vous pouvez compléter votre panier en élargissant la zone recherche
                        </p>
                    </div>
 
                    <div class="">
                        <img alt="" src="assets/images/help-search/tableau_2.png" />
                    </div>
                </div>
                <div class="">
                    <strong class="">Obtenir plus d’information pour une sélection pertinente</strong>
   
                    <p class="">
                        Vous pouvez ouvrir le tableau de l’aperçu grâce aux flèches de déploiement « &gt; » et « &gt;&gt; » et obtenir ainsi un descriptif plus complet
                    </p>
                    <img alt="" src="assets/images/help-search/tableau_3.png" />
                </div>
            </div>
        </div>
 
        <div class="card card-body mb-4">
            <h3 class="text-secondary mb-3">
                <img alt="" src="assets/images/help-search/icons/refresh.png" />&nbsp;Mise à jour de la sélection
            </h3>
 
            <div class="d-flex">
                <div class="">
                    <p class="card-text">
                        Lorsque le bouton « Recalculer automatiquement les références » est coché, chaque changement de critère est pris en compte.
                    </p>
 
                    <p class="card-text">
                        Si vous souhaitez modifier votre position sur la carte sans impacter votre sélection, vous pouvez décocher « Recalculer automatiquement les références »
                    </p>
                </div>
 
                <div class="card-text">
                    <img alt="" src="assets/images/help-search/recalculer.png" />
                </div>
            </div>
        </div>
    </div>
</div>